<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester date ssystem college department sclass keyword="教師編號、教師姓名">
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>班級</th>
                            <th>教師編號-教師姓名</th>
                            <th>日期</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.ClassRecordID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.ClassRecordID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="教師編號-教師姓名"><b-button size="sm" variant="link" @click="edit(item.ClassRecordID)">{{item.TeacherNo}}-{{item.TeacherName}}</b-button></td>
                        <td data-th="日期">{{item.Date|date('yyyy/mm/dd')}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit"></Detail>
        <inputmodal id="input" sample="/template/classrecord.xlsx" url="/api/classrecord/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './classrecordDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'classrecord',
        api: '/api/classrecord/',
        components: { Detail }
    });
</script>

<style>
</style>